import { createSelector } from 'reselect';

const lineItems = items => items;

const getLineItemTotal =
  createSelector(
    lineItems,
    items => items.reduce((curr, next) => curr + (next.total || 0), 0),
  );

export default getLineItemTotal;



// WEBPACK FOOTER //
// ./client/app/selectors/lineItemTotal.js